import React, { Fragment, useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useParams, Redirect } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { Button } from "react-bootstrap";

import { Row, Col, Card, Tabs, Tab, Nav } from "react-bootstrap";

import EquipmentDetail from "./EquipmentDetail";

import { Formik } from "formik";
import * as Yup from "yup";
import { useCollection } from "../../../hook/useCollection";
import { db } from "../../../firebase";
import {
  setDoc,
  getDoc,
  getDocs,
  collection,
  updateDoc,
  doc,
  query,
  orderBy,
} from "firebase/firestore";

import { notifyTopRight, notifyWarning, notifyError } from "../toast/SetToast";
import Toast from "../toast/SetToast";

import useQueryParams from "../../../hook/useQueryParam";
import { useAuth } from "../../../context/AuthContext";

const loginSchema = Yup.object().shape({
  username: Yup.string()
    .min(3, "Your username must consist of at least 3 characters ")
    .max(50, "Your username must consist of at least 3 characters ")
    .required("Please enter a username"),
  password: Yup.string()
    .min(5, "Your password must be at least 5 characters long")
    .max(50, "Your password must be at least 5 characters long")
    .required("Please provide a password"),
});

const EquipmentPage = (props) => {
  const profileData = {
    hn: "",
    email: "",
    titleTh: "",
    firstnameTh: "",
    lastnameTh: "",
    nationalId: "",
    titleEn: "",
    firstnameEn: "",
    lastnameEn: "",
    dateOfBirth: "",
    status: "",
    ethnicity: "",
    nationality: "",
    religion: "",
    bloodType: "",
    note: "",
    gender: "",
    occupation: "",
    mobile: "",
    telephone: "",
    address1: "",
    address2: "",
    province: "",
    postcode: "",
    medicineIntolerance: "",
    healthInsurance: "",
    other: "",
    emergencyContact: "",
    relationship: "",
    emergencyContactPhone: "",
    nodeRef: "",
  };
  const { currentUser } = useAuth();

  const [showPassword, setShowPassword] = useState(false);
  const profileRef = useRef(profileData);
  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();

  const { queryParams, setQueryParams } = useQueryParams({
    id: null,
  });

  const submitHandler = async (e) => {
    try {
      e.preventDefault();
      const ref = doc(db, "patients", profileRef.current["hn"].value);
      const docSnap = await getDoc(ref);
      const updateData = {
        hn: profileRef.current["hn"].value,
        email: emailRef.current.value,
        titleTh: profileRef.current["titleTh"].value,
        firstnameTh: profileRef.current["firstnameTh"].value,
        lastnameTh: profileRef.current["lastnameTh"].value,
        nationalId: profileRef.current["nationalId"].value,
        titleEn: profileRef.current["titleEn"].value,
        firstnameEn: profileRef.current["firstnameEn"].value,
        lastnameEn: profileRef.current["lastnameEn"].value,
        dateOfBirth: profileRef.current["dateOfBirth"].value,
        status: profileRef.current["status"].value,
        ethnicity: profileRef.current["ethnicity"].value,
        nationality: profileRef.current["nationality"].value,
        religion: profileRef.current["religion"].value,
        bloodType: profileRef.current["bloodType"].value,
        note: profileRef.current["note"].value,
        gender: profileRef.current["gender"].value,
        occupation: profileRef.current["occupation"].value,
        mobile: profileRef.current["mobile"].value,
        telephone: profileRef.current["telephone"].value,
        address1: profileRef.current["address1"].value,
        address2: profileRef.current["address2"].value,
        province: profileRef.current["province"].value,
        postcode: profileRef.current["postcode"].value,
        medicineIntolerance: profileRef.current["medicineIntolerance"].value,
        healthInsurance: profileRef.current["healthInsurance"].value,
        other: profileRef.current["other"].value,
        emergencyContact: profileRef.current["emergencyContact"].value,
        relationship: profileRef.current["relationship"].value,
        emergencyContactPhone:
          profileRef.current["emergencyContactPhone"].value,
        nodeRef: profileRef.current["nodeRef"].value,
      };

      if (docSnap.exists()) {
        await updateDoc(ref, {
          updateData,
        });
      } else {
        await setDoc(ref, {
          updateData,
        });
      }

      if (passwordRef.current.value !== passwordConfirmRef.current.value) {
        notifyError("Password do not match");
        return;
      }
    } catch (err) {
      console.log(err);
      notifyError(`Error ${err}`);
    }
  };

  const tabData = [
    {
      name: "Detail",
      icon: "user",
      content: function (props, setState) {
        return (
          <EquipmentDetail
            equipment={equipment}
            tickets={documents}
            onEdit={setState}
          />
        );
      },
    },
    // {
    //   name: "Activity",
    //   icon: "clipboard",
    //   content: function (props, setState) {
    //     return <ProductActivity cpap={props} />;
    //   },
    // },
    // {
    //   name: "Files",
    //   icon: "clipboard",
    //   content: function (props, setState) {
    //     return <ProductFiles cpap={props} />;
    //   },
    // },
  ];

  const { id } = useParams();
  const [equipment, setEquipment] = useState(profileData);
  const [isLoading, setIsLoading] = useState(false);

  const { documents, error } = useCollection(
    "tickets",
    ["updatedAt", "desc"],
    ["equipmentId", "==", id]
  );

  // console.log(documents, error);

  useEffect(async () => {
    // console.log(patientInfo);
    // props.startSetCpaps();
    // if (patientInfo.hn != "") {
    //   setIsLoading(false);
    //   return;
    // }
    // console.log("id: ", id);
    setIsLoading(true);
    const ref = doc(db, "equipments", id);
    const docSnap = await getDoc(ref).catch((error) => console.log(error));

    setEquipment(docSnap.data());

    setIsLoading(false);
  }, [id]);

  return (
    <>
      <PageTitle
        activeMenu={""}
        motherMenu="Equipments"
        motherLink="/equipment-list"
      />

      {isLoading ? (
        <></>
      ) : (
        <Card>
          <Card.Header>
            <Card.Title className="col-xxl-auto pr-5">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>{equipment.serialNumber}</div>
              </div>
            </Card.Title>
          </Card.Header>
          <Card.Body>
            <div className="default-tab">
              <Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
                <Nav as="ul" className="nav-tabs">
                  {tabData.map((data, i) => (
                    <Nav.Item as="li" key={i}>
                      <Nav.Link eventKey={data.name.toLowerCase()}>
                        <i className={`la la-${data.icon} mr-2`} />
                        {data.name}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
                <Tab.Content className="pt-4">
                  {tabData.map((data, i) => (
                    <Tab.Pane eventKey={data.name.toLowerCase()} key={i}>
                      {data.content(equipment)}
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Tab.Container>
            </div>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default EquipmentPage;
